import { ReactElement } from 'react'

import { PushpinFilled, PushpinOutlined } from '@ant-design/icons'
import { Tooltip } from 'antd'

import { IconButton } from 'components/Buttons'

interface PinToggleButtonProps {
    isPinned: boolean
    onClick: () => void
    disabled?: boolean
}

export function PinToggleButton({
    isPinned,
    onClick,
    disabled,
}: PinToggleButtonProps): ReactElement {
    return (
        <Tooltip title={isPinned ? 'Remove pin' : 'Pin for quick access'}>
            <IconButton
                icon={isPinned ? <PushpinFilled /> : <PushpinOutlined />}
                disabled={disabled}
                size="small"
                color="primary"
                variant="text"
                style={{
                    background: 'none',
                }}
                onClick={onClick}
            />
        </Tooltip>
    )
}
